import {BESCHEID_ANGELEGT, BESCHEID_BEANTRAGT, BESCHEID_IN_BEARBEITUNG, bescheidstatusIdToObj,} from "../consts/bescheidsstatus";
import {BETREIBER} from "../consts/funktionaleRollen";
import routes from "../consts/routes.json";
import {getCurrentUser} from "../services/JwtService";
import {userHasAnyRole} from "../utils/SecurityUtils";
import {
    isReal,
    nullableString,
    requiredDate,
    requiredEnumWerteListeObjekt,
    requiredNumber,
    requiredObject,
    requiredString,
    requiredWerteListeObjekt,
} from "../utils/Validator";
import {anforderungsartIdToObj} from "../consts/anforderungart";
import {createColumn, createDateColumn, createNumberColumn} from "../utils/ColumnUtils";
import {formatDate} from "../utils/DateUtils";

export const createInitialBescheid = (betriebsId, bescheidQualitaet) => {
    return {
        behoerde: getCurrentUser().behoerde,
        auflagen: [],
        anforderungen: [],
        messstellen: [],
        ablaufdatum: new Date('3000-01-01'),
        betrieb: {id: betriebsId},
        bescheidQualitaet: bescheidQualitaet,
        bescheidsstatus: userHasAnyRole(BETREIBER)
            ? bescheidstatusIdToObj(BESCHEID_ANGELEGT)
            : bescheidstatusIdToObj(BESCHEID_IN_BEARBEITUNG),
    };
};

export const createBescheidSchema = () => {
    return {
        ...createBescheidAntragSchema(),
        bescheidsdatum: requiredDate(),
    };
};

export const createBescheidAntragSchema = () => {
    return {
        bescheidsstatus: requiredEnumWerteListeObjekt(),
        bescheidart: requiredWerteListeObjekt(),
        bescheidQualitaet: requiredEnumWerteListeObjekt()
    };
};

export const createInitialAnforderung = (anforderungArt, messstellenId, gueltigAb, gueltigBis) => {
    return {anforderungArt: anforderungsartIdToObj(anforderungArt), messstelle: {id: messstellenId}, gueltigAb, gueltigBis};
};

export const createBehoerdlicheFestlegungSchema = () => {
    return {
        ...createAnforderungSchema(),
        wert: isReal({requiredField: false, positive: false}),
        einheit: requiredWerteListeObjekt(),
    };
};

export const createSelstuebwerwachungSchema = () => {
    return {
        ...createAnforderungSchema(),
    };
};

const createAnforderungSchema = () => {
    return {
        parameterNr: requiredWerteListeObjekt(),
        gueltigBis: requiredDate(),
    };
};

export const createFreigegebenerBescheidSchema = () => {
    return {
        ...createBescheidSchema(),
        ablaufdatum: requiredDate(),
        aktenzeichen: requiredString(),
        behoerde: requiredObject({id: requiredNumber()}),
        bemerkung: nullableString(),
        bescheidsdatum: requiredDate(),
        betrieb: requiredObject({id: requiredNumber()}),
    };
};

export function calculateBescheidLink(bescheid, modus = "modus=l") {
    let pfad = `${routes.BETRIEBSAKTE_RAW}/${bescheid.betrieb.id}`;
    const middlePath =
        bescheid?.bescheidsstatus?.id === BESCHEID_ANGELEGT || bescheid?.bescheidsstatus?.id === BESCHEID_BEANTRAGT ? "antrag" : "bescheid";
    pfad = `${pfad}/${middlePath}/${bescheid.id}/bescheiddaten?${modus}`;
    return pfad;
}

const wertColumnStylings = {paddingLeft: "1em", paddingRight: "1em", textAlign: "right"};
export const buildDefaultBehoerdlicheFestlegungColumns = () => {
    return [
        createColumn("parameterNr.value", "Parameter"),
        createNumberColumn("wert", "Wert", wertColumnStylings),
        createColumn("einheit.value", "Einheit"),
        createDateColumn("gueltigAb", "Gültig ab"),
        createDateColumn("gueltigBis", "Gültig bis"),
        createColumn("artAnforderungWert.value", "Art"),
        createColumn("probenahme.value", "Probenahme"),
    ];
};

export const buildDefaultSelbstueberwachungsColumns = () => {
    return [
        createDateColumn("gueltigAb", "Gültig ab"),
        createDateColumn("gueltigBis", "Gültig bis"),
        createColumn("parameterNr.value", "Parameter"),
        createColumn("probenahme.value", "Probenahme"),
        createColumn("haeufigkeit.value", "Häufigkeit"),
        createColumn("vorlageMesswerte.value", "Vorlage"),
    ];
};

export const buildBescheidTitle = ({bescheidsdatum, aktenzeichen, bescheidId}) => {
    return (bescheidsdatum ? formatDate(new Date(bescheidsdatum)) : bescheidId) + (aktenzeichen ? " (" + aktenzeichen + ")" : "");
};
